import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";

import { CommonModule } from '@angular/common';
import { AfterViewInit } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { LanguageService } from '../../services/language.service';


@Component({
  selector: 'app-partners-carrousel',
  standalone: true,
  imports: [NgxSpinnerModule,CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './partners-carrousel.component.html',
  styleUrls: ['./partners-carrousel.component.css']
})
export class PartnersCarrouselComponent implements AfterViewInit {
  listImages: any[] = [];
  texts: any;

  constructor(private spinner: NgxSpinnerService, private http: HttpClient, private lang: LanguageService) {
    this.texts = this.lang.getWebisteTexts().home.partners;
  }
  @ViewChild('swiperEl', { static: false }) swiperEl!: ElementRef;

  async ngOnInit() {
    if (typeof window === 'undefined') {
      return;
    }
    this.listImages = await this.getImages();
    // Wait for DOM update before initializing swiper
    setTimeout(() => this.initSwiper(), 0);
    setTimeout(() => {
      this.updateSwiperParams();
    }, 100); // timeout ensures slides are rendered
  }

  ngAfterViewInit() {
    if (typeof window === 'undefined') {
      return;
    }
    register(); // in case component loads before global register
    setTimeout(() => {
      this.updateSwiperParams(true);
    }, 100); // timeout ensures slides are rendered
  }

  private updateSwiperParams(isDefaultMobile = false): void {
    if (typeof window === 'undefined') {
      return;
    }
    if (this.swiperEl) {
      const swiperInstance = this.swiperEl.nativeElement.swiper;
      if (swiperInstance) {
        if (isDefaultMobile) {
          swiperInstance.params.slidesPerView = 1; // default mobile
        } else if (window.screen.width >= 768) {
          swiperInstance.params.slidesPerView = 3;
        }
        swiperInstance.params.breakpoints = {
          0: { slidesPerView: 1, spaceBetween: 10 },
          768: { slidesPerView: 3, spaceBetween: 20 }
        };
        swiperInstance.update(); // important!
      }
    }
  }

  async getImages() {
    this.spinner.show();
    try {
      const data = await this.http
        .get<any>('https://mundoev.com/index.php?fc=module&module=crrimagemanager&controller=api')
        .toPromise();
      return data.images || [];
    } catch (error) {
      //console.error('There was an error!', error);
      return [];
    } finally {
      this.spinner.hide();
    }
  }

  initSwiper() {
    if (typeof document === 'undefined') {
      return;
    }
    const swiperEl = document.querySelector('swiper-container');
    if (swiperEl) {
      //console.log('Swiper ready:', swiperEl.swiper);
    } else {
      //console.warn('Swiper container not found');
    }
  }

  openurl(url: string) {
    //console.log("Opening URL:", url);
    if (url && url != '') {
      window.open(url, '_blank');
    }
  }
}
